import React from 'react'
import { Routes } from '@/core/router/routes'
import { ComunicadoEnvioHomeBoxCortex } from '@/modules/comunicado-utils/ui/comunicado-envio-home-box-cortex'
import { useHomeOnboarding } from '../hooks/use-home-onboarding'
import { Carousel } from '../components/carousel'
import { InfoCard } from '../components/info-card'
import { Footer } from '@/modules/home/components/footer'
import { BibliotecaVirtualLastCreatedBox } from '@/modules/biblioteca-virtual/components'

export const HomeDesktop = () => {
  const { linkHelpTec } = useHomeOnboarding()

  return (
    <div className={'flex flex-col mb-deca'}>
      <div className={'flex mb-deca gap-x-deca'}>
        <Carousel linkHelpTec={linkHelpTec} />
        <InfoCard />
      </div>
      <div className={'flex flex-col lg:flex-row gap-deca'}>
        <ComunicadoEnvioHomeBoxCortex pathRoute={Routes.COMUNICADOS} />
        <BibliotecaVirtualLastCreatedBox
          pathRoute={Routes.BIBLIOTECA_VIRTUAL}
        />
      </div>
      <Footer />
    </div>
  )
}
